<template>
  <div class="legend-switch">
    <span :class="{ 'legend-active': legendStatus }">图例</span>&nbsp;
    <el-switch
      v-model="legendStatus"
      active-color="#13ce66"
      @change="$emit('switchStatus', legendStatus)"
    >
    </el-switch>
  </div>
</template>

<script>
export default {
  props: {
    legendDefaultStatus: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      legendStatus: this.legendDefaultStatus,
    }
  },
}
</script>

<style lang="scss">
$fontColor: #eee;
.legend-switch {
  position: absolute;
  right: 4%;
  bottom: 0;
  display: flex;
  align-items: center;
  color: #aaa;
  .legend-active {
    color: $fontColor;
  }
  .el-switch__core {
    height: calc(1em + 2px) !important;
    width: 30px !important;
    &::after {
      height: calc(1em - 2px);
      width: calc(1em - 2px);
      left: 0 !important;
      margin-left: 1px !important;
    }
  }
  .el-switch.is-checked .el-switch__core::after {
    left: 100% !important;

    margin-left: -13px !important;
  }
}
</style>
